<div class="flex flex-col gap-4 text-left" data-test-id="pricing-summary">
	<span class="h4 mb-0">
		{{ 'compositions.pricing-summary.price-based-on' | translate }}
	</span>
	<div class="flex flex-col gap-1.5">
		@if (occupancyString !== '') {
			<div
				class="flex flex-row items-center text-lg"
				data-test-id="occupancy"
			>
				<svg-icon
					class="mr-2 block size-4 text-dark-primary"
					src="assets/icons/icon-bed-double.svg"
				/>
				{{ occupancyString }}
			</div>
		}
		@if (startDate() && endDate()) {
			<div
				class="flex flex-row items-center text-lg"
				data-test-id="date-range"
			>
				<svg-icon
					class="mr-2 block size-4 text-dark-primary"
					src="assets/icons/icon-calendar.svg"
				/>
				{{ startDate() }} - {{ endDate() }}
			</div>
		}
	</div>
	<vp-receipt-summary
		[currency]="currency()"
		[items]="items()"
		[tax]="taxes()"
		[total]="total()"
		receiptDescription="compositions.pricing-summary.price-based-on"
	/>
</div>
